import LegalPage from './LegalPage';
import { COMPANY } from './legalConstants';

export default function Herroepingsrecht() {
  return (
    <LegalPage title="Herroepingsrecht" testId="legal-page-withdrawal">
      <p>
        Als consument (B2C) beschikt u over een wettelijk
        herroepingsrecht van <strong>14 kalenderdagen</strong>, zonder
        opgave van reden en zonder boete (Boek VI WER, art. VI.47 e.v.).
      </p>

      <h2>1. Termijn</h2>
      <p>
        De termijn van 14 dagen begint te lopen vanaf de dag na de dag
        waarop u (of een door u aangewezen derde, anders dan de
        vervoerder) het laatste artikel van uw bestelling fysiek in
        ontvangst heeft genomen.
      </p>

      <h2>2. Hoe uw herroepingsrecht uitoefenen?</h2>
      <p>
        Stuur binnen de termijn van 14 dagen een ondubbelzinnige
        verklaring naar <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>{' '}
        waarin u meedeelt dat u de overeenkomst herroept. U kan
        daarvoor het modelformulier voor herroeping gebruiken (zie
        onderaan deze pagina), maar dit is niet verplicht.
      </p>

      <h2>3. Gevolgen van de herroeping</h2>
      <p>
        Wij betalen u alle ontvangen betalingen terug, inclusief de
        standaard leveringskosten, en dit binnen uiterlijk 14 dagen
        nadat wij geïnformeerd zijn over uw beslissing tot herroeping.
        Wij mogen wachten met terugbetaling tot wij de goederen
        teruggekregen hebben, of tot u bewezen heeft dat u de goederen
        heeft teruggezonden, naargelang welk tijdstip eerder valt.
      </p>
      <p>
        U dient de goederen onverwijld, en in elk geval niet later dan
        14 dagen na de dag waarop u uw beslissing om de overeenkomst
        te herroepen heeft meegedeeld, aan ons terug te zenden. De
        directe kosten van het terugzenden van de goederen zijn voor
        uw rekening, tenzij anders overeengekomen.
      </p>

      <h2>4. Uitzonderingen — verzegelde voedingssupplementen</h2>
      <p>
        Conform Boek VI WER art. VI.53, 5° kan het herroepingsrecht
        uitgesloten zijn voor:
      </p>
      <ul>
        <li>
          Verzegelde goederen die om redenen van gezondheidsbescherming
          of hygiëne niet geschikt zijn om te worden teruggezonden en
          waarvan de verzegeling na de levering is verbroken.
        </li>
      </ul>
      <p>
        Concreet betekent dit dat <strong>ongeopende en verzegelde</strong>{' '}
        voedingssupplementen wel kunnen worden teruggenomen binnen de
        14-dagentermijn, maar dat <strong>geopende of ontzegelde</strong>{' '}
        verpakkingen om hygiënische redenen kunnen worden uitgesloten
        van het herroepingsrecht.
      </p>
      <p>
        <em>
          TODO: juridische review — de exacte afbakening tussen
          "verzegeld/onverzegeld" voor onze productlijn (flessen,
          blisters, sachets) wordt nog bevestigd door counsel vóór
          live. Tot bevestiging hanteren wij bovenstaande conservatieve
          regel.
        </em>
      </p>

      <h2>5. Staat van de geretourneerde goederen</h2>
      <p>
        U bent enkel aansprakelijk voor de waardevermindering van de
        goederen die het gevolg is van een behandeling die verder
        gaat dan nodig is om de aard, de kenmerken en de werking van
        de goederen vast te stellen.
      </p>

      <h2>6. Modelformulier voor herroeping</h2>
      <p>
        Dit modelformulier alleen invullen en terugzenden wanneer u
        de overeenkomst wilt herroepen.
      </p>
      <pre className="bg-muted/40 p-4 rounded text-xs whitespace-pre-wrap">{`Aan: ${COMPANY.legalName}
E-mail: ${COMPANY.email}

Ik / Wij (*) deel/delen (*) u hierbij mede dat ik / wij (*) onze
overeenkomst betreffende de verkoop van de volgende goederen
herroep / herroepen (*):

Besteld op (*) / Ontvangen op (*):
Naam consument(en):
Adres consument(en):
Handtekening van consument(en) (alleen wanneer dit formulier op
papier wordt ingediend):
Datum:

(*) Doorhalen wat niet van toepassing is.`}</pre>

      <h2>7. B2B</h2>
      <p>
        Het wettelijke herroepingsrecht geldt enkel voor consumenten
        (B2C). Voor verkoop tussen ondernemingen (B2B) is dit
        herroepingsrecht <strong>niet</strong> van toepassing.
      </p>
    </LegalPage>
  );
}
